export default {
  // any array should have unique values as the values are used as keys
  // months
  formattedShortMonths: [
    'Oca',
    '\u015eub',
    'Mar',
    'Nis',
    'May',
    'Haz',
    'Tem',
    'A\u011fu',
    'Eyl',
    'Eki',
    'Kas',
    'Ara',
  ],
  months: [
    'Ocak',
    '\u015eubat',
    'Mart',
    'Nisan',
    'May\u0131s',
    'Haziran',
    'Temmuz',
    'A\u011fustos',
    'Eyl\u00fcl',
    'Ekim',
    'Kas\u0131m',
    'Aral\u0131k',
  ],
  months_calendar: {
    January: 'Ocak',
    February: '\u015eubat',
    March: 'Mart',
    April: 'Nisan',
    May: 'May\u0131s',
    June: 'Haziran',
    July: 'Temmuz',
    August: 'A\u011fustos',
    September: 'Eyl\u00fcl',
    October: 'Ekim',
    November: 'Kas\u0131m',
    December: 'Aral\u0131k',
  },
  // weekdays
  weekdays: ['Pz', 'Pt', 'Sa', '\u00c7a', 'Pe', 'Cu', 'Ct'],
  weekdays_booking_container: {
    Sunday: 'Pazar',
    Monday: 'Pazartesi',
    Tuesday: 'Sal\u0131',
    Wednesday: '\u00c7ar\u015famba',
    Thursday: 'Per\u015fembe',
    Friday: 'Cuma',
    Saturday: 'Cumartesi',
  },
  weekdays_calendar: {
    Sun: 'Paz',
    Mon: 'Pzt',
    Tue: 'Sal',
    Wed: '\u00c7ar',
    Thu: 'Per',
    Fri: 'Cum',
    Sat: 'Cmt',
  },
  // additional translations
  today: 'Bugün',
  tomorrow: 'Yarın',
};
